import React from "react";
import { withRouter } from "react-router";
import makeStyles from "@mui/styles/makeStyles";
import moment from "moment";
import {
  Checkbox,
  TableRow,
  TableCell,
  Chip,
  Typography,
  Collapse
} from "@mui/material";
import PropTypes from "prop-types";
import ExpandLess from "@mui/icons-material/ExpandLess";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  chip: {
    marginLeft: theme.spacing(1)
  },
  expandIcon: {
    float: "right"
  },
  checkboxColumn: {
    borderBottom: "none"
  },
  selectedRow: {
    background: theme.palette.action.hover
  },
  row: theme.mixins.hoverableRow,
  selectedCell: {
    borderTop: `${theme.palette.primary.main} solid 2px`,
    borderBottom: "none",
    fontWeight: 500
  },
  cell: {
    borderBottom: `${theme.palette.divider} solid 1px`
  },
  messageRowHidden: {
    display: "none"
  },
  messageContent: {
    padding: theme.spacing(2.25, 8, 6, 8),
    background: theme.palette.action.hover,
    borderBottom: `${theme.palette.primary.main} solid 2px`
  }
}));
function MessagesRow(props) {
  const classes = useStyles();
  const { row } = props;
  const [expanded, setExpanded] = React.useState(
    !props.location.state && !props.expanded
      ? false
      : (props.location.state &&
          props.location.state.expandMessageId === row.id) ||
          props.expanded
  );
  const [checked, setChecked] = React.useState(false);
  React.useEffect(() => {
    if (props.location.state && props.location.state.expandMessageId) {
      let newState = props.location.state;
      props.onExpand(row, newState.expandMessageId);
      delete newState.expandMessageId;
      props.history.replace({ ...props.history.location, newState });
    }
  }, [expanded]);

  React.useEffect(() => {
    setChecked(props.checked);
    setExpanded(
      !props.location.state && !props.expanded
        ? false
        : (props.location.state &&
            props.location.state.expandMessageId === row.id) ||
            props.expanded
    );
  }, [row]);

  const onExpand = () => {
    if (!expanded && row.isNew) {
      props.onExpand(row.id);
    }
    props.onExpandClick(row, !expanded);
    setExpanded(!expanded);
  };
  const onCheckbox = ev => {
    ev.stopPropagation();
    props.onCheckboxClick(row.id, !checked);
    setChecked(!checked);
  };

  return (
    <>
      <TableRow
        key={row.subject}
        className={expanded ? classes.selectedRow : classes.row}
        onClick={onExpand}
      >
        <TableCell
          padding="checkbox"
          className={clsx(classes.checkboxColumn, {
            [classes.selectedCell]: expanded
          })}
        >
          <Checkbox checked={checked} onClick={ev => onCheckbox(ev)} />
        </TableCell>
        <TableCell className={expanded ? classes.selectedCell : classes.cell}>
          {row.subject}
          {row.isNew && (
            <Chip
              className={classes.chip}
              color="primary"
              size="small"
              label={<Typography variant="overline">New</Typography>}
            />
          )}
        </TableCell>
        <TableCell className={expanded ? classes.selectedCell : classes.cell}>
          {row.from}
        </TableCell>
        <TableCell className={expanded ? classes.selectedCell : classes.cell}>
          {row.date && moment(row.date).format("MMM D, YYYY h:mm A")}
          {expanded ? (
            <ExpandLess color="primary" className={classes.expandIcon} />
          ) : null}
        </TableCell>
      </TableRow>
      <TableRow
        className={clsx({
          [classes.messageRowHidden]: !expanded
        })}
      >
        <TableCell colSpan="4" className={classes.messageContent}>
          <Collapse in={expanded}>
            <div dangerouslySetInnerHTML={{ __html: row.description }} />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

MessagesRow.propTypes = {
  row: PropTypes.objectOf(PropTypes.any).isRequired,
  onExpand: PropTypes.func.isRequired,
  onCheckboxClick: PropTypes.func.isRequired
};

export default withRouter(MessagesRow);
